<shared-modal-type-popup [modalData]="modalData" [center]="true" [mobilePreserve]="true" [size]="size"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-member-card">

    <shared-barcode class="modal-for-member-card__barcode" [memberId]="modalData.memberId"></shared-barcode>

    <div class="modal-for-member-card__label">
        Scan every purchase for rewards
    </div>

    <shared-header class="modal-for-member-card__member-name" type="3" [inverted]="true" [center]="true"
        marginBottom="sm">
        {{memberFirstName$ | async}}
    </shared-header>

</shared-modal-type-popup>